import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useFacilities } from "@/hooks/useFacilities";
import { FacilityCard } from "@/components/FacilityCard";
import { todayISO } from "@/lib/constants";

export default function Facilities() {
  const [facilities] = useFacilities();
  const [counts, setCounts] = useState({});

  useEffect(() => {
    api.get("/bookings", { params: { date_from: todayISO() } }).then((r) => {
      const c = {};
      r.data.filter((b) => b.booking_status !== "annullata").forEach((b) => { c[b.facility_slug] = (c[b.facility_slug] || 0) + 1; });
      setCounts(c);
    });
  }, []);

  return (
    <div data-testid="facilities-page" className="space-y-8">
      <div>
        <p className="eyebrow">Patrimonio comunale</p>
        <h1 className="mt-2 font-serif text-4xl sm:text-5xl font-semibold text-slate-900">Strutture</h1>
        <p className="mt-2 text-slate-600">Seleziona una struttura per aggiornarne lo stato, le tariffe e il registro note.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {facilities.map((f, i) => <FacilityCard key={f.slug} facility={f} index={i} upcoming={counts[f.slug] || 0} large />)}
      </div>
    </div>
  );
}
